export default {"src":"/_next/static/media/illustrations.f0f8b7cf.svg","height":214,"width":268,"blurWidth":0,"blurHeight":0};